/**
 * Test Constants - UI Text Values
 *
 * Strictly contains ONLY UI element visible text strings (labels, buttons, etc.)
 *
 * RULES:
 * - Must EXACTLY match case and text as displayed in the UI
 * - Only contains static text (no interpolated/combined strings)
 * - No error messages, notifications, or other non-UI-text strings
 * - Maintain STRICT alphabetical order
 *
 * Usage:
 * - For test assertions and element interactions
 * - As selectors for text-based element locating
 */

export const ACCEPT_TEXT = 'Accept';
export const ACCESS_DENIED_TEXT = 'Access Denied';
export const ACKNOWLEDGE_THE_TEXT = 'and acknowledge the';
export const ACTIVATE_TEXT = 'Activate';
export const ACTIVE_STAFF_TEXT = 'Active staff';
export const ACTIVE_TEXT = 'Active';
export const ADDED_SUGAR_TEXT = 'Added Sugar (g)';
export const ADDED_THIS_MONTH_TEXT = 'added this month';
export const ADDING_NEW_CARD_TEXT = 'Adding new card...';
export const ADDITIONAL_CONTACT_TEXT = 'Additional Contact';
export const ADDITIONAL_INFO_OF_TEXT = 'Additional Info';
export const ADDRESS_1_TEXT = 'Address 1';
export const ADDRESS_2_TEXT = 'Address 2';
export const ADD_BLEND_TEXT = 'Add Blend';
export const ADD_BOTTLE_CAPACITY_TEXT = 'Add Bottle Capacity';
export const ADD_BOTTLE_PRICE_TEXT = 'Add Bottle Price';
export const ADD_BOTTLE_SIZE_TEXT = 'Add Bottle Size';
export const ADD_CARRIER_TEXT = 'Add Carrier';
export const ADD_COATING_FORMULATION_COMPONENT_TEXT = 'Add Coating Formulation Component';
export const ADD_EXCIPIENT_LABEL_TEXT = 'Add Label Excipient';
export const ADD_EXCIPIENT_TEXT = 'Add Excipient & Carrier';
export const ADD_EXCIPIENT_TYPE_TEXT = 'Add Excipient Type';
export const ADD_INGREDIENT_TEXT = 'Add Ingredient';
export const ADD_NEW_CARD_TEXT = 'Add New Card';
export const ADD_NEW_TEXT = 'Add New';
export const ADD_NEW_USER_TEXT = 'Add new user';
export const ADD_PRODUCT_EXCIPIENT_TEXT = 'Add Product Excipient';
export const ADD_PRODUCT_SIZE_TEXT = 'Add Product Size';
export const ADD_SERVING_SIZE_TEXT = 'Add Serving Count';
export const ADD_STAFF_TEXT = 'Add Staff';
export const ADD_SUBSCRIPTION_TEXT = 'Add Subscription';
export const ADD_SUB_COMPONENT_TEXT = 'Add Sub Component';
export const ADD_SUB_PRODUCT_TYPE_TEXT = 'Add Sub Product Type';
export const ADD_SUPPLIER_TEXT = 'Add Supplier';
export const ADD_SWEETENER_COMPONENT_TEXT = 'Add Sweetener Component';
export const ADD_SWEETENER_ELEMENT_TEXT = 'Add Sweetener Element';
export const ADD_SWEETENER_TEXT = 'Add Sweetener';
export const ADD_SYRUP_BASE_INGREDIENTS_TEXT = 'Add Syrup Base Ingredient';
export const ADD_TEXT = 'Add';
export const ADD_USER_TEXT = 'Add User';
export const AGREE_TO_TEXT = 'I agree to the';
export const ALLERGENS_TEXT = 'Allergens';
export const ALL_TEXT = 'All';
export const ALL_TIME_TEXT = 'All Time';
export const ALREADY_HAVE_AN_ACCOUNT_TEXT = 'Already have an account?';
export const ALREADY_SUBSCRIBED_TEXT = 'Already Subscribed';
export const AMOUNT_TEXT = 'Amount';
export const ANDROID_TEXT = 'Android';
export const APPLY_TEXT = 'Apply';
export const APP_LOADING_TEXT = 'App is loading please wait...';
export const ARE_YOU_SURE_TEXT = 'Are you sure you want to proceed?';
export const ARSENIC_TEXT = 'Arsenic (mcg/serv)';
export const AVERAGE_PARTICLE_SIZE_TEXT = 'Average Particle Size';
export const BACK_TEXT = 'Back';
export const BEADLETS_TEXT = 'Beadlets';
export const BIOTIN_TEXT = 'Biotin (mcg)';
export const BLEND_NAME_TEXT = 'Blend Name';
export const BLEND_TEXT = 'Blend';
export const BORON_TEXT = 'Boron (mg)';
export const BOTTLE_CAPACITY_IS_CREATING_TEXT = 'Bottle Capacity is creating...';
export const BOTTLE_CAPACITY_IS_UPDATED_TEXT = 'Bottle Capacity is updated...';
export const BOTTLE_CAPACITY_TEXT = 'Bottle Capacity';
export const BOTTLE_CAP_TEXT = 'Bottle Cap';
export const BOTTLE_TYPE_TEXT = 'Bottle Type';
export const BOTTLE_COST_TEXT = 'Bottle Cost';
export const BOTTLE_FILL_TEXT = 'Bottle Fill';
export const BOTTLE_PRICE_IS_CREATING_TEXT = 'Bottle Price is creating...';
export const BOTTLE_PRICE_IS_UPDATED_TEXT = 'Bottle Price is updated...';
export const BOTTLE_PRICE_TEXT = 'Bottle Price';
export const BOTTLE_SIZE_IS_CREATED_TEXT = 'Bottle Size is creating...';
export const BOTTLE_SIZE_IS_UPDATED_TEXT = 'Bottle Size is updated...';
export const BOTTLE_SIZE_TEXT = 'Bottle Size';
export const BOTTLE_TEXT = 'Bottle';
export const BULK_DENSITY_TEXT = 'Bulk Density';
export const DENSITY_TEXT = 'Density (g/ml)';
export const DENSITY_INFO_MESSAGE = 'This value is used for volume calculation.(Tapped/Bulk Density)';
export const BY_TEXT = 'By';
export const CADMIUM_TEXT = 'Cadmium (mcg/serv)';
export const CALCIUM_TEXT = 'Calcium (mg)';
export const CALCULATE_TEXT = 'Calculate';
export const CALORIES_TEXT = 'Calories (kCal)';
export const CANCELING_TEXT = 'Canceling';
export const CANCELLED_TEXT = 'Cancelled';
export const CANCEL_PLAN_TEXT = 'Cancel Plan';
export const CANCEL_TEXT = 'Cancel';
export const CAPACITY_OVERRIDE_TEXT = 'Capacity Override';
export const CAPSULES_TEXT = 'Capsules';
export const CAPSULE_PRICE_TEXT = 'Capsule Price';
export const ORGANIC_PERCENTAGE = 'Organic Percentage';
export const ORGANIC_TEXT = 'Organic';
export const CAPSULE_TEXT = 'Capsule';
export const CARD_NUMBER_TEXT = 'Card Number';
export const CARD_EXPIRY_TEXT = 'MM/YY';
export const CARD_CVC_TEXT = 'CVC';
export const CARD_HOLDER_NAME_TEXT = 'Card Holder Name';
export const ADD_BANK_ACCOUNT_TEXT = 'Add Bank Account';
export const PAYMENT_TYPE_CARD_LABEL = 'Card';
export const PAYMENT_TYPE_ACH_LABEL = 'ACH';
export const FORM_TEXT = 'Form';
export const PLATFORM_TEXT = 'Platform';
export const SYRUP_BASE_TEXT = 'Syrup Base';
export const DOSAGE_FORM_BREAKDOWN_TEXT = 'Dosage Form Breakdown';
export const CARBOHYDRATES_TEXT = 'Carbohydrates (g)';
export const CARRIERS_TEXT = 'Carriers';
export const CC_TEXT = 'CC';
export const CELERY_TEXT = 'Celery';
export const CHANGE_PAYMENT_METHOD_TEXT = 'Update Payment Method';
export const ADD_NEW_PAYMENT_METHOD_TEXT = 'Add New Payment Method';
export const CHANGE_PASSWORD_TEXT = 'Change Password';
export const CHILD_RESISTANT_TEXT = 'Child Resistant';
export const CHLORIDE_TEXT = 'Chloride (mg)';
export const CHOLESTEROL_TEXT = 'Cholesterol (mg)';
export const CHOLINE_TEXT = 'Choline (mg)';
export const CHOOSE_YOUR_PLAN_TEXT = 'Choose your plan';
export const CHROMIUM_TEXT = 'Chromium (mcg)';
export const CITY_TEXT = 'City';
export const CLEAR_TEXT = 'Clear';
export const CLOSE_TEXT = 'Close';
export const COATING_COLORS_HEX_TEXT = 'Coating Colors Hex';
export const COATING_COST_TEXT = 'Coating Cost';
export const COATING_FORMULATION_COMPONENT_TEXT = 'Coating Formulation Component';
export const COATING_FORMULATION_IS_CREATING_TEXT = 'Coating Formulation is creating...';
export const COATING_FORMULATION_IS_UPDATED_TEXT = 'Coating Formulation is updated...';
export const COATING_TEXT = 'Coating';
export const COATING_WEIGHT_TEXT = 'Coating Weight';
export const COLOR_TEXT = 'Color';
export const COMING_SOON_TEXT = 'Coming Soon';
export const COMMON_NAME_TEXT = 'Common Name';
export const COMPANY_NAME_TEXT = 'Company Name';
export const CONFIRM_NEW_PASSWORD_TEXT = 'Confirm New Password';
export const CONFIRM_PASSWORD_MATCH = 'Passwords must match';
export const CONFIRM_PASSWORD_TEXT = 'Confirm Password';
export const CONFIRM_TEXT = 'Confirm';
export const CONTACT_TEXT = 'Contact';
export const CONVERSION_COST_TEXT = 'Conversion Cost';
export const COPPER_TEXT = 'Copper (mg)';
export const COST_DOLLAR_KG_TEXT = 'Cost ($/kg) ';
export const COST_PERCENTAGE_TEXT = 'Cost %';
export const MG_VOLUME_TEXT = 'Mg Volume';
export const COST_PER_KG_TEXT = 'Cost (Per KG)';
export const COST_PER_MG_TEXT = 'Cost (Per MG)';
export const COST_PER_SERVING_TEXT = 'Cost Per Serving';
export const COST_TEXT = 'Cost ';
export const COST_VIA_CO_MFG = 'Cost via Co-MFG';
export const COST_VIA_MFG = 'Cost via MFG';
export const COUNTRY_OF_MANUFACTURING_TEXT = 'Country of Final Manufacturing';
export const COUNTRY_OF_ORIGIN_TEXT = 'Country of Origin';
export const COUNTRY_TEXT = 'Country';
export const CO_MFG_COST_TEXT = 'Co-MFG Cost';
export const CO_MFG_COST_PERCENTAGE_TEXT = 'Co-MFG Cost %';
export const CO_MFG_COST_TYPE_TEXT = 'Co-MFG Cost Type';
export const CREATED_AT_TEXT = 'Created At';
export const CREATED_BY_TEXT = 'Created By';
export const CREATED_INGREDIENTS_TEXT = 'Ingredients Created';
export const CREATE_FORMULA_TEXT = 'Create Formula';
export const CREATE_SWEETENER_ELEMENT_TEXT = 'Create Sweetener Element....';
export const CRUSTACEANS_TEXT = 'Crustaceans';
export const CSV_SHEET_TEXT = 'CSV Sheet';
export const CURRENT_MONTH_USERS_TEXT = 'Current Month Users';
export const DASHBOARD_TEXT = 'Dashboard';
export const DATE_RANGE_TEXT = 'Date Range';
export const DEACTIVATE_TEXT = 'Deactivate';
export const DECLINE_TEXT = 'Decline';
export const DECREASE_THIS_MONTH_TEXT = 'decrease this month';
export const DEFAULT_TEXT = 'Default';
export const DEFINING_AMOUNT_TEXT = 'Defining Amount';
export const DELETE_TEXT = 'Delete';
export const DESCRIPTION_TEXT = 'Description';
export const NOTES_TEXT = 'Notes';
export const DESICCANT_TEXT = 'Desiccant';
export const DESIGNATION_TEXT = 'Designation';
export const DETAILS_TEXT = 'Details';
export const DESIRED_SERVING_SIZE = 'Desired Serving Size';
export const DIETARY_FIBER_TEXT = 'Dietary Fiber (g)';
export const DISCARD_AND_LEAVE = 'Discard & Leave';
export const DON_T_HAVE_AN_ACCOUNT_TEXT = "Don't have an account?";
export const DOSAGE_FORM_REPORT_TEXT = 'Dosage  Report';
export const DOSAGE_FORM_TEXT = 'Dosage Form';
export const DOSAGE_TEXT = 'Dosage';
export const DOSAGE_TYPE_TEXT = 'Dosage Type';
export const DOWNLOADING_TEXT = 'Downloading...';
export const DOWNLOAD_REPORT_TEXT = 'Download Report';
export const DOWNLOAD_TEXT = 'Download';
export const DRAFT_TEXT = 'Draft';
export const DUPLICATE_FORMULA_TEXT = 'Duplicate Formula';
export const DUPLICATE_INGREDIENT_TEXT = 'Duplicate Ingredient';
export const DUPLICATE_SUPPLIER_TEXT = 'Duplicate Supplier';
export const DUPLICATE_TEXT = 'Duplicate';
export const EDIT_BOTTLE_CAPACITY_TEXT = 'Edit Bottle Capacity';
export const EDIT_BOTTLE_PRICE_TEXT = 'Edit Bottle Price';
export const EDIT_BOTTLE_SIZE_TEXT = 'Edit Bottle Size';
export const EDIT_COATING_FORMULATION_COMPONENT_TEXT = 'Edit Coating Formulation Component';
export const EDIT_EXCIPIENT_LABEL_TEXT = 'Edit Label Excipient';
export const EDIT_EXCIPIENT_TEXT = 'Edit Excipient & Carrier';
export const EDIT_EXCIPIENT_TYPE_TEXT = 'Edit Excipient Type';
export const EDIT_FORMULA_TEXT = 'Edit Formula';
export const EDIT_INGREDIENT_TEXT = 'Edit Ingredient';
export const EDIT_PRODUCT_EXCIPIENT_TEXT = 'Edit Product Excipient';
export const EDIT_PRODUCT_FORMULATION_TYPE_TEXT = 'Edit Product Formulation Type';
export const EDIT_PRODUCT_SIZE_TEXT = 'Edit Product Size';
export const EDIT_PRODUCT_TYPE_TEXT = 'Edit Product Type';
export const EDIT_PROFILE_TEXT = 'Edit Profile';
export const EDIT_SERVING_SIZE_TEXT = 'Edit Serving Count';
export const EDIT_STAFF_TEXT = 'Edit Staff';
export const EDIT_SUB_PRODUCT_TYPE_TEXT = 'Edit Sub Product Type';
export const EDIT_SUPPLIER_TEXT = 'Edit Supplier';
export const EDIT_SWEETENER_COMPONENT_TEXT = 'Edit Sweetener Component';
export const EDIT_SWEETENER_ELEMENT_TEXT = 'Edit Sweetener Element';
export const EDIT_SWEETENER_ELEMENT_UPDATED_TEXT = 'Sweetener Element is updated...';
export const EDIT_SWEETENER_TEXT = 'Edit Sweetener';
export const EDIT_SYRUP_BASE_INGREDIENT_TEXT = 'Edit Syrup Base Ingredient';
export const EDIT_TEXT = 'Edit';
export const EDIT_USER_TEXT = 'Edit User';
export const EMAIL_ADDRESS_TEXT = 'Email address';
export const EMAIL_TEXT = 'Email';
export const ENHANCEMENTS_ADDED_TEXT = 'Enhancements Added';
export const ENTER_DETAIL_TEXT = 'Enter your details below';
export const ERROR_FETCHING_PLANS_TEXT = ' Error fetching plans. Please contact support.';
export const ERROR_LOADING_PLANS = 'Error loading plans. Please try again later.';
export const EXCEL_SHEET_TEXT = ' Excel Sheet';
export const EXCEL_TEXT = 'Excel';
export const EXCIPIENT_AND_CARRIER_TEXT = 'Excipient & Carrier';
export const EXCIPIENT_COST_TEXT = 'Excipient Cost';
export const EXCIPIENT_GENERATOR_TEXT = 'Excipient Generator';
export const EXCIPIENT_IS_CREATING_TEXT = 'Excipient & Carrier is creating...';
export const EXCIPIENT_IS_UPDATED_TEXT = 'Excipient & Carrier is updated...';
export const EXCIPIENT_LABEL_IS_CREATING_TEXT = 'Excipient Label is creating...';
export const EXCIPIENT_LABEL_IS_UPDATED_TEXT = 'Excipient Label is updated...';
export const EXCIPIENT_LABEL_TEXT = 'Excipient Label';
export const EXCIPIENT_TEXT = 'Excipient';
export const EXCIPIENT_TYPES_TEXT = 'Excipient Type';
export const EXCIPIENT_TYPE_IS_CREATING_TEXT = 'Excipient Type is creating...';
export const EXCIPIENT_TYPE_TEXT = 'Choose the excipient profile';
export const EXCIPIENT_WEIGHT_TEXT = 'Excipient Weight';
export const EXPIRES_ON_TEXT = 'Expires on';
export const EXPORT_TEXT = 'Export';
export const FACT_BOX_TEXT = 'Fact Box';
export const FACT_SHEET_TEXT = 'Fact Sheet';
export const FEATURES_ADDED_TEXT = 'Features Added';
export const FETCHING_INVOICE_TEXT = 'Fetching Invoice...';
export const FETCHING_PLANS_TEXT = 'Fetching Plans...';
export const FILING_PERCENTAGE_TEXT = 'Filing Percentage';
export const FIRST_NAME_TEXT = 'First Name';
export const FISH_TEXT = 'Fish';
export const FLAVOR_COST_TEXT = 'Flavor Cost';
export const FLAVOR_SYSTEM_TEXT = 'Flavor System';
export const FLAVOR_TYPE_TEXT = 'Flavor Type';
export const FLAVOR_WEIGHT_TEXT = 'Flavor Weight';
export const FOLATE_TEXT = `Folate/Folic Acid (mcg)`;
export const FOLIC_ACID_TEXT = 'Folic Acid';
export const FOOD_FOLATE_TEXT = 'Food Folate (mcg)';
export const FORGOT_PASSWORD_HEADING = 'Forgot your password?';
export const FORGOT_PASSWORD_TEXT = 'Forgot password';
export const FORMULAS_CREATED_TEXT = 'Formulas Created';
export const FORMULAS_TEXT = 'Formulas';
export const FORMULATION_SYRUP_TYPE_INGREDIENT_TEXT = 'Ingredient syrup type';
export const FORMULATION_SYRUP_TYPE_TEXT = 'Formulation syrup type';
export const FORMULATION_TEXT = 'Formulation';
export const FORMULATION_TYPES_TEXT = 'Formulation Types';
export const FORMULA_AS_EXCEL_TEXT = 'Formula as Excel';
export const FORMULA_DETAILS_TEXT = 'Formula Details';
export const FORMULA_FETCH_TEXT = 'Formula is Fetching...';
export const FORMULA_IS_CREATING_TEXT = 'Formula is Creating...';
export const FORMULA_IS_UPDATING_TEXT = 'Formula is Updating...';
export const FORMULA_NAME_TEXT = 'Formula Name';
export const FORMULA_TEXT = 'Formula';
export const FROM_TEXT = 'From';
export const GENERAL_TEXT = 'General';
export const GENERATE_PASSWORD_TEXT = 'Generate Random Password';
export const GLUTEN_TEXT = 'Gluten';
export const GO_TEXT = 'Go';
export const GO_TO_HOME_TEXT = 'Go to Home';
export const GO_TO_SIGNIN_BUTTON = 'Go To Sign In';
export const GRAMS_TEXT = 'Grams';
export const GRAPH_NOT_FOUND_MSG = 'Page Not Found';
export const GUMMY_OVERAGE_TEXT = 'Gummy Overage';
export const GUMMY_TEXT = 'Gummy';
export const HEAVY_METALS_TEXT = 'Heavy Metals';
export const IMAGE_FORMAT_TEXT = 'Allowed *.jpeg, *.jpg, *.png, *.svg, *.gif';
export const IMAGE_MAX_SIZE_TEXT = 'Max size of 3 MB';
export const IMAGE_SIZE_ERROR_MESSAGE = 'Image cannot be more than 3 MB';
export const INACTIVE_TEXT = 'Inactive';
export const INCREASE_THIS_MONTH_TEXT = 'increase this month';
export const INFO_TEXT = 'Info';
export const INGREDIENTS_COST_TEXT = 'Ingredients Cost';
export const INGREDIENTS_CREATED_TEXT = 'Ingredients Created';
export const INGREDIENTS_REPORT_TEXT = 'Ingredients Report';
export const INGREDIENTS_TEXT = 'Ingredients';
export const DV_CONSTRAINTS_TEXT = 'DV Constraints';
export const INGREDIENT_ALREADY_EXIST_TEX = 'Ingredient Already added';
export const INGREDIENT_IS_CREATING_TEXT = 'Ingredient is Creating...';
export const INGREDIENT_TEXT = 'Ingredient';
export const INGREDIENT_WEIGHT_TEXT = 'Ingredient Weight';
export const ING_COST_CONTRIBUTION_TEXT = 'Ing Cost %';
export const INNER_CAPSULE_POLYMER_TEXT = 'Type of Inner capsule polymer';
export const INNER_CAPSULE_PRICE_TEXT = 'Inner Capsule Price';
export const INNER_CAPSULE_TABLET_TEXT = 'Inner Capsule Tablet';
export const PROPAGATE_TO_ORGANIZATIONS_TEXT = 'Propagate to all organizations';
export const PROPAGATE_TO_ORGANIZATIONS_INFO =
  'When checked, saving copies this record to every organization that does not already have it. Organizations that already have it keep their existing copy unchanged. Runs in the background and may take a few minutes.';
export const INNER_COMPONENT_COST_TEXT = 'Inner Component Cost';
export const INVALID_IMAGE_EXTENSION_MESSAGE = 'Invalid image extension';
export const INVALID_TOKEN_TEXT = 'Invalid Toke, Kindly login again';
export const INVOICES_TEXT = 'Invoices';
export const INVOICE_ID_TEXT = 'Invoice ID';
export const IN_PROGRESS_TEXT = 'In Progress';
export const IODINE_TEXT = 'Iodine (mcg)';
export const IOS_TEXT = 'iOS';
export const IRON_TEXT = 'Iron (mg)';
export const IS_CHILD_RESISTANT_TEXT = 'Is Child Resistant';
export const IS_CR_TEXT = 'Is CR';
export const JOINING_DATE_TEXT = 'Joining Date';
export const KOSHER_TEXT = 'Kosher';
export const LABEL_CLAIM_TEXT = 'Label Claim';
export const LABEL_NAME_INFO = '(Herbs, Amino acids, Specialty, etc)';
export const LABEL_NAME_TEXT = 'Label Name';
export const LAST_NAME_TEXT = 'Last Name';
export const LAYER_1_TEXT = 'Layer 1';
export const LAYER_2_TEXT = 'Layer 2';
export const LAYER_3_TEXT = 'Layer 3';
export const LEAD_TEXT = 'Lead (mcg/serv)';
export const LET_S_FINISH_POWERING_YOU_UP_TEXT = "Let's finish powering you up!";
export const SEVEN_DAY_FREE_TRIAL_TEXT = '7-day free trial';
export const LID_SIZE_TEXT = 'Lid Size';
export const LID_TEXT = 'Lid';
export const LOAD_ADD_TEXT = 'Load Add';
export const LOAD_ADD_UNIT_TEXT = 'Load Add Unit';
export const LOG_IN_BUTTON_TEXT = 'Login';
export const LOG_OUT_BUTTON_TEXT = 'Log Out';
export const LOH_COST_TEXT = 'LOH Cost';
export const LOSS_ON_DRYING_TEXT = 'Loss on drying (LOD)';
export const LUPIN_TEXT = 'Lupin';
export const MAGNESIUM_TEXT = 'Magnesium (mg)';
export const MANAGEMENT_TEXT = 'Management';
export const MANGANESE_TEXT = 'Manganese (mg)';
export const MARK_AS_DEFAULT_TEXT = ' Mark as Default';
export const MAX_STAFF = 'Max Staff';
export const MAX_TEXT = 'Max (mg)';
export const MISCELLANEOUS_COST_USD_TEXT = 'Miscellaneous Cost (USD)';
export const MISCELLANEOUS_COST_TEXT = 'Miscellaneous Cost';
export const MISCELLANEOUS_COST_INFO = `Use this field to add any additional costs related to manufacturing—such as testing, freight, or packaging—not already captured in conversion or LOH costs.`;
export const MERCURY_TEXT = 'Mercury (mcg/serv)';
export const METRICS_TEXT = 'Metrics';
export const MG_PER_SERVING_TEXT = 'Mg Per Serving';
export const MG_TEXT = 'mg';
export const MICRO_TEXT = 'Micro';
export const MILK_TEXT = 'Milk';
export const MINI_TABLETS_FORMULATION_TEXT = 'Mini-Tablets Formulation';
export const MINI_TABLET_COATING_TEXT = 'Mini-Tablet Coating';
export const MINI_TABLET_COLOR_TEXT = 'Mini-Tablet Color';
export const MIN_TEXT = 'Min (mg)';
export const MOISTURE_IN_GRAMS_TEXT = 'Moisture (g)';
export const MOLLUSCS_TEXT = 'Molluscs';
export const MOLYBDENUM_TEXT = 'Molybdenum (mcg)';
export const MONOUNSATURATED_FAT_TEXT = 'Monounsaturated Fat (g)';
export const MOST_USERS_TEXT = 'Most Users';
export const MUSTARD_TEXT = 'Mustard';
export const MY_FORMULAS_TEXT = 'My Formulas';
export const NAME_TEXT = 'Name';
export const INFANTS_TEXT = 'Infants';
export const FOOD_COMPONENT_TEXT = 'Food Component';
export const ADULTS_AND_CHILDREN_TEXT = 'Adults and Children';
export const CHILDREN_1_TO_3_YEARS_TEXT = 'Children 1 to 3 Years';
export const PREGNANT_AND_LACTATING_WOMEN_TEXT = 'Pregnant and Lactating Women';
export const NATURE_TEXT = 'Nature';
export const NECKBAND_COST_TEXT = 'Neckband Cost';
export const NEW_PASSWORD_TEXT = 'New Password';
export const NEW_STAFF_TEXT = 'New Staff';
export const NEW_USERS_TEXT = 'New Users';
export const NEXT_TEXT = 'Next';
export const NIACIN_TEXT = 'Niacin (mg)';
export const NON_GMO_TEXT = 'NON-GMO';
export const NO_CARRIER_DESCRIPTION_TEXT = 'Click the button below to add';
export const NO_CARRIER_TEXT = 'No Carriers';
export const NO_DATA_FOUND = 'No Records Found';
export const NO_INGREDIENT_TEXT = 'No Ingredients Added';
export const NO_NUTRIENTS_FOUND_TEXT = 'No Macro Nutrient';
export const NO_SUBSCRIPTION_PLAN_TEXT = 'No subscription plans are currently available';
export const NO_SUB_COMPONENT_TEXT = 'No Sub Components';
export const NO_UPLOAD_TEXT = 'No Upload';
export const NUMBERS_TEXT = 'Numbers';
export const NUTRIENTS_TEXT = 'Nutrients';
export const NUTRIENTS_WEIGHTS_TEXT = 'Macro/Micro Nutrient Contribution';
export const NUTRIENT_NAME_TEXT = 'Show source of nutrients';
export const N_A_TEXT = 'N/A';
export const OLD_PASSWORD_TEXT = 'Old Password';
export const OPTIONAL_TEXT = 'Optional';
export const ORGANIC_NUMERICAL_TEXT = '% Organic (numerical)';
export const ORGANIZATION_NAME_TEXT = 'Organization Name';
export const ORGANIZATION_TEXT = 'Organization';
export const ORG_ADMIN_TEXT = 'Org Admin';
export const ORG_FORMULAS_TEXT = 'Organizational Formulas';
export const ORG_INGREDIENTS_TEXT = 'Organizational Ingredients';
export const ORG_OR_ADMIN_TEXT = 'Org/OrgAdmin';
export const OTP_TEXT = '2FA';
export const OUTER_CAPSULE_POLYMER_TEXT = 'Type of Outer capsule polymer';
export const OUTER_CAPSULE_PRICE_TEXT = 'Outer Capsule Price';
export const OZ_TEXT = 'OZ';
export const PACKAGE_ESTIMATOR_TEXT = 'Package Estimator';
export const PAGE_NOT_FOUND_TEXT = 'Sorry, page not found!';
export const PAID_TEXT = 'Paid';
export const PANTOTHENIC_ACID_TEXT = 'Pantothenic Acid (mg)';
export const PASSWORD_SET_SUCCESS_TITLE = 'Password Successfully Set!';
export const PASSWORD_TEXT = 'Password';
export const PATH_FORWARD_LOGO_TEXT = 'Path Forward';
export const PAYMENT_CARD_TEXT = 'PAYMENT CARD';
export const PAYMENT_METHOD_TEXT = 'Payment Method';
export const PAYMENT_DETAILS_TEXT = 'Payment Details';
export const PAYMENT_FETCHING_TEXT = 'Fetching your payment methods...';
export const PAYMENT_METHOD_NOT_FOUND = 'No payment methods available.';
export const PAYMENT_PROCESSING_TEXT = 'Processing your payment...';
export const PAY_NOW_TEXT = 'Pay Now';
export const PDF_TEXT = 'PDF';
export const PEANUT_TEXT = 'Peanut';
export const PENDING_TEXT = 'Pending';
export const PERCENTAGE_TEXT = 'Percentage';
export const PER_1000_TEXT = '/ 1000';
export const PER_100_PRICE_TEXT = 'Per 1000 Costs';
export const PER_UNIT_COST_TEXT = 'Per Unit Cost';
export const PER_KG_COST_TEXT = 'Per KG Cost';
export const PER_SERVING_COST_TEXT = 'Per Serving Cost';
export const PER_YEAR_TEXT = 'Per Year';
export const PHONE_TEXT = 'Phone';
export const PHOSPHORUS_TEXT = 'Phosphorus (mg)';
export const PLAN_TEXT = 'Plan';
export const PLAN_TRIAL_TEXT = 'Every plan includes a 7-day free trial';
export const NO_CREDIT_CARD_REQUIRED_TEXT = 'No credit card required. Cancel anytime.';
export const CLICK_SUBSCRIBE_TO_START_YOUR_TRIAL_TEXT =
  'Click Subscribe to Start your Trial, no Payment information required for Free 7-Day Trial';
export const PLEASE_AGREE_TO_THE_TEXT = 'Please agree to the';
export const PLEASE_SELECT_A_CARD = 'Please select a card';
export const PLEASE_SELECT_DOSAGE_FORM_OR_TYPE = 'Please select any dosage form or type';
export const PLEASE_SELECT_INGREDIENT = 'Please select any ingredient';
export const POLYUNSATURATED_FAT_TEXT = 'Polyunsaturated Fat (g)';
export const POTASSIUM_TEXT = 'Potassium (mg)';
export const POTENCY_TEXT = 'Potency';
export const POWDER_TEXT = 'Powder';
export const PRICE_ID_TEXT = 'priceId';
export const PRICE_TEXT = 'Price';
export const PRIMARY_CATEGORY_TEXT = 'Primary Category';
export const PRIVACY_POLICY_TEXT = 'Privacy Policy';
export const PROCESSING_TEXT = 'Processing....';
export const PRODUCT_EXCIPIENT_IS_CREATING_TEXT = 'Product Excipient is creating...';
export const PRODUCT_EXCIPIENT_IS_UPDATED_TEXT = 'Product Excipient is updated...';
export const PRODUCT_EXCIPIENT_TEXT = 'Product Excipient';
export const PRODUCT_FORMULATION_SYRUP_TYPE_TEXT = 'Product Formulation Syrup Type';
export const PRODUCT_FORMULATION_TEXT = 'Product Formulation';
export const PRODUCT_FORMULATION_TYPE_IS_UPDATED_TEXT = 'Product Formulation Type is updated...';
export const PRODUCT_FORMULATION_TYPE_TEXT = 'Product Formulation Type';
export const PRODUCT_INGREDIENT_TEXT = 'Product ingredient';
export const PRODUCT_LOADING_TEXT = 'Loading your product details...';
export const PRODUCT_SIZE_IS_CREATING_TEXT = 'Product Size is creating...';
export const PRODUCT_SIZE_IS_UPDATED_TEXT = 'Product Size is updated...';
export const PRODUCT_SIZE_TEXT = 'Product Size';
export const PRODUCT_TEXT = 'Product';
export const PRODUCT_TYPE_IS_UPDATED_TEXT = 'Product Type is updated...';
export const PRODUCT_TYPE_TEXT = 'Product Type';
export const PROFILE_TEXT = 'Profile';
export const PROTEIN_BASE_TEXT = 'Protein Base';
export const PROTEIN_TEXT = 'Protein (g)';
export const PROBIOTIC_TEXT = 'Probiotic(Billion CFU/G)';
export const QT_MG_TEXT = 'QT Mg';
export const QT_PER_MG_TEXT = 'QT Per Mg';
export const QUOTE_SHEET_TEXT = 'Quote Sheet';
export const RANK_TEXT = 'Rank';
export const REACTIVATION_USER_SUBSCRIPTION_TEXT =
  'To reactivation the user later, you will need to purchase a new subscription';
export const RECENT_FORMULAS_TEXT = 'Recent Formulas';
export const RECOMMENDED_TEXT = 'Recommended';
export const REGISTER_BTN_TEXT = 'Register';
export const REMEMBER_ME_TEXT = 'Remember me';
export const REMOVE_IMAGE = 'Remove Image';
export const REMOVE_TEXT = 'Remove';
export const UNBLEND_TEXT = 'Unblend';
export const REPORTS_TEXT = 'Reports';
export const REQUEST_QUOTE_SHEET_TEXT = 'Request Quotation Sheet';
export const REQUEST_SENT_TITLE = 'Request sent successfully!';
export const RIBOFLAVIN_TEXT = 'Riboflavin (mg)';
export const ROLE_TEXT = 'Role';
export const R_Q_S_TEXT = 'RFQ';
export const SAND_COATING_FORMULATION_TEXT = 'Sand Coating Formulation';
export const SAND_COATING_TEXT = 'Sand Coating';
export const SAND_COMPONENT_TEXT = 'Sand Component';
export const SATURATED_FAT_TEXT = 'Saturated Fat (g)';
export const SAVE_AS_DRAFT_TEXT = 'Save as Draft';
export const SAVE_CHANGES_TEXT = 'Save Changes';
export const SAVE_DRAFT_AND_LEAVE_TEXT = 'Save Draft & Leave';
export const SAVE_TEXT = 'Save';
export const SAVE_YEARLY_TEXT = 'Saving $400 a year';
export const SAVING_TEXT = 'Saving';
export const SCIENTIFIC_NAME_INFO = 'Label name for Vitamins and Minerals';
export const SCIENTIFIC_NAME_TEXT = 'Scientific / Botanical Name';
export const SCOPE_TEXT = 'Scope';
export const SEARCH_AND_ADD_INGREDIENTS_TEXT = 'Search & add ingredients';
export const SEARCH_TEXT = 'Search';
export const SEAT_TEXT = 'Seat';
export const SECONDARY_CATEGORY_TEXT = 'Secondary Category';
export const SELECT_PLAN_TEXT = 'Select A Plan';
export const SELENIUM_TEXT = 'Selenium (mcg)';
export const SERVING_COUNT_TEXT = 'Serving Count';
export const SERVING_PER_CONTAINER = 'Serving Per Container';
export const SERVING_SIZE_IS_CREATED_TEXT = 'Serving count is creating...';
export const SERVING_SIZE_IS_UPDATED_TEXT = 'Serving count is updated...';
export const SERVING_SIZE_TEXT = 'Serving Size';
export const SERVING_TEXT = 'Serving';
export const SERVING_UNIT_TEXT = 'Serving Unit';
export const SESAME_SEEDS_TEXT = 'Sesame Seeds';
export const SETTINGS_TEXT = 'Settings';
export const SET_PASSWORD_TEXT = 'Set Password';
export const SFP_NFP_TEXT = 'SFP/NFP';
export const SHEET_NOT_FOUND_TEXT = 'Sheet not found';
export const SHELF_LIFE_TEXT = 'Shelf Life (Months) ';
export const SHELL_FISH = 'Shell Fish';
export const SHOW_ALL_TEXT = 'Show All';
export const SHOW_B3 = 'Show B3';
export const SIGN_IN_TEXT = 'Sign in';
export const SIGN_UP_TEXT = 'Sign up';
export const SIZE_TEXT = 'Size';
export const SODIUM_TEXT = 'Sodium (mg)';
export const SOURCE_TEXT = 'Source';
export const SOY_TEXT = 'Soy';
export const INGREDIENT_TYPE_TEXT = 'Ingredient Type';
export const SPEC_SHEET_TEXT = 'Product Specification';
export const STAFF_DEACTIVATION_TEXT = 'Staff Deactivation in';
export const STAFF_DETAILS_TEXT = 'Staff Details';
export const STAFF_IS_CREATING_TEXT = 'Staff is creating...';
export const STAFF_TEXT = 'Staff';
export const STATE_TEXT = 'State';
export const STATUS_TEXT = 'Status';
export const STRIPE_NOT_LOADED_TEXT = 'Stripe not loaded';
export const SUBSCRIBE_TEXT = 'Subscribe';
export const SUBSCRIPTION_CANCELLED_TEXT = 'Subscription cancelled successfully';
export const SUBSCRIPTION_EXPIRED_TEXT = 'Subscription Expired';
export const SUBSCRIPTION_TEXT = 'Subscription';
export const SUB_COMPONENT_TEXT = 'Sub Component';
export const SUB_PRODUCT_TYPE_IS_CREATING_TEXT = 'Sub Product Type is Creating...';
export const SUB_PRODUCT_TYPE_IS_UPDATED_TEXT = 'Sub Product Type is updated...';
export const SUB_PRODUCT_TYPE_TEXT = 'Sub Product Type';
export const SUB_TYPE_TEXT = 'Sub-Type';
export const SUCCESS_TEXT = 'Success';
export const OVERAGE_TEXT = 'Overage';
export const SHOW_CFU_TEXT = 'Show CFU';
export const SUGGESTED_OVERAGE_TEXT = 'Suggested Overage';
export const SUGGESTED_SUPPLIER_TEXT = 'Suggested Supplier';
export const SULPHITES_TEXT = 'Sulphites';
export const SUMMARY_TEXT = 'Summary';
export const SUPPLIERS_TEXT = 'Suppliers';
export const SUPPLIER_IS_CREATING_TEXT = 'Supplier is Creating...';
export const SUPPLIER_TEXT = 'Supplier';
export const SWEETENER_COMPONENT_IS_CREATING_TEXT = 'Sweetener component is creating...';
export const SWEETENER_COMPONENT_IS_UPDATED_TEXT = 'Sweetener component is updated...';
export const SWEETENER_COMPONENT_TEXT = 'Sweetener Component';
export const SWEETENER_COST_TEXT = 'Sweetener Cost';
export const SWEETENER_ELEMENT_TEXT = 'Sweetener Element';
export const SWEETENER_IS_CREATED_TEXT = 'Sweetener is creating...';
export const SWEETENER_IS_UPDATED_TEXT = 'Sweetener is updated...';
export const SWEETENER_SYSTEM_TEXT = 'Sweetener';
export const FLAVOR_TEXT = 'Flavor';
export const SWEETENER_TYPE_TEXT = 'Sweetener Type';
export const SWEETENER_WEIGHT_TEXT = 'Sweetener Weight';
export const SYRUP_BASE_INGREDIENTS_TEXT = 'Syrup Base Ingredients';
export const SYRUP_BASE_INGREDIENT_IS_CREATING_TEXT = 'Syrup Base Ingredient is Creating...';
export const TABLET_COATING_TEXT = 'Tablet Coating';
export const TABLET_COLOR_TEXT = 'Tablet Color';
export const TABLET_SIZE_TEXT = 'Tablet Size';
export const TABLET_TEXT = 'Tablet';
export const TABLET_TYPE_TEXT = 'Tablet Type';
export const TAPPED_DENSITY_TEXT = 'Tapped Density';
export const TERMS_AND_CONDITIONS_TEXT = 'Terms & Conditions';
export const TERMS_OF_USE_TEXT = 'Terms of Use';
export const THIAMIN_TEXT = 'Thiamin (mg)';
export const TOKEN_NOT_FOUND_TEXT = 'Token not found';
export const TOP_CONTRIBUTOR_TEXT = 'Top Contributor';
export const TOP_TEXT = 'Top';
export const TOTAL_ACTIVE_USERS_TEXT = 'Total Active Users';
export const TOTAL_BILLED_TEXT = 'Total Billed';
export const TOTAL_FAT_TEXT = 'Total Fat (g)';
export const TOTAL_FORMULAS_TEXT = `Total ${FORMULAS_TEXT}`;
export const TOTAL_INGREDIENTS_TEXT = 'Total Ingredients';
export const TOTAL_ORG_ADMINS_TEXT = 'Total Organization Admins';
export const TOTAL_STAFF_TEXT = 'Total Staff';
export const TOTAL_SUGARS_TEXT = 'Total Sugars (g)';
export const TOTAL_TEXT = 'Total';
export const TOTAL_USERS_TEXT = 'Total Users';
export const TOTAL_WEIGHT_TEXT = 'Total Weight';
export const TO_START_USING_YOUR_ACCOUNT_TEXT = 'to start using your account.';
export const TRADEMARK_TEXT = 'Trademark Name';
export const TRANS_FAT_TEXT = 'Trans Fat (g)';
export const TREE_NUTS_TEXT = 'Tree Nuts';
export const TREND_ANALYSIS_TEXT = 'Trend Analysis';
export const TRIAL_END_DATE_TEXT = 'Trial End Date';
export const TRYPTOPHAN_TEXT = 'Tryptophan';
export const TYPE_OF_CAPSULE_POLYMER_TEXT = 'Type of Capsule Polymer';
export const TYPE_TEXT = 'Type';
export const UNABLE_TO_COLLECT = 'Unable to Collect';
export const UNIT_TEXT = 'Unit';
export const UNSAVED_FORMULA_TEXT = 'Unsaved Formula';
export const UPDATE_BLEND_TEXT = 'Update Blend';
export const UPDATE_IMAGE = 'Update Image';
export const UPGRADE_PLAN_TEXT = 'Upgrade Plan';
export const UPLOAD_IMAGE = 'Upload photo';
export const UPLOAD_IMAGE_TEXT = 'Upload Image';
export const UP_TIME_TEXT = 'Up Time';
export const USAGE_GRAPH_TEXT = 'Usage Graph';
export const USAGE_TEXT = 'Usage';
export const USERS_REPORT_TEXT = 'Users Report';
export const USERS_TEXT = 'Users';
export const USER_DETAILS_TEXT = 'User Details';
export const USE_EXISTING_PAYMENT_METHOD_TEXT = 'Use Existing Payment Method';
export const USE_SEVEN_DAYS_TEXT = 'Use 7 Days for Free';
export const YEAR_TEXT = 'Year';
export const USD_TEXT = 'USD';
export const VALUE_TEXT = 'Value';
export const VEGAN_TEXT = 'Vegan';
export const VERIFICATION_MESSAGE_SENT_TEXT = 'A verification code has been sent to you email';
export const VERIFY_OTP_MESSAGE = 'Enter the 6 digit code sent to your email';
export const VERIFY_OTP_TEXT = 'Verify 2FA';
export const VERIFY_TEXT = 'Verify';
export const VIEW_ALL_TEXT = 'View All';
export const VIEW_TEXT = 'View';
export const VITAMIN_A_TEXT = 'Vitamin A (mcg)';
export const VITAMIN_B12_TEXT = 'Vitamin B12 (mcg)';
export const VITAMIN_B6_TEXT = 'Vitamin B6 (mg)';
export const VITAMIN_C_TEXT = 'Vitamin C (mg)';
export const VITAMIN_D_TEXT = 'Vitamin D (mcg)';
export const VITAMIN_E_TEXT = 'Vitamin E (mg)';
export const VITAMIN_K2_TEXT = 'Vitamin K2 (mg)';
export const WARNING_TEXT = 'Warning';
export const WEB_TEXT = 'Web';
export const WEIGHTS_PERCENTAGE_TEXT = 'Weight %';
export const WEIGHT_TEXT = 'Weight';
export const WHEAT_TEXT = 'Wheat';
export const WORK_IN_FORMAT_TEXT = 'Works in Format';
export const ZINC_TEXT = 'Zinc (mg)';
export const EMPTY_WEIGHT_TEXT = 'Empty Capsule Weight (mg)';
export const GUMMY_WEIGHT_TEXT = 'Gummy Weight (mg)';
export const EDIT_FLAVOR_TEXT = 'Edit Flavor';
export const ADD_FLAVOR_TEXT = 'Add Flavor';
export const CAPACITY_TEXT = 'Capacity';
export const FLAVOR_IS_UPDATED_TEXT = 'Flavor is updated...';
export const FLAVOR_IS_CREATED_TEXT = 'Flavor is creating...';
export const YOUR_PLAN_TEXT = 'Your Plan';
export const ZIP_CODE_TEXT = 'Zip Code';
export const EDIT_DV_CONSTRAINTS_TEXT = 'Edit DV Constraints';
export const DV_CONSTRAINTS_IS_UPDATED_TEXT = 'DV Constraints is updated...';
export const AGE_GROUP_AT_LEAST_ONE_PRIMARY_TEXT = 'At least one age group must be Primary';
export const AGE_GROUPS_TEXT = 'Age Groups';
export const AGE_GROUP_TYPE_TEXT = 'Age Group Type';
export const AGE_GROUP_TYPE_PRIMARY_TOOLTIP = 'For one age group DV only, choose Primary';
export const DV_CONSTRAINTS_TYPE_TEXT = 'DV Constraints Type';

/**
 * Application Message Constants
 *
 * Contains all user-facing messages, notifications, and alerts shown in the UI.
 *
 * Rules:
 * - Must be complete, properly punctuated sentences
 * - Maintain consistent tone (friendly but professional)
 * - Group related messages together
 * - Sorted alphabetically by constant name (case-sensitive)
 * - No dynamic/interpolated values - use full message strings
 *
 * Categories:
 * - Account/authentication messages
 * - Form validation messages
 * - System notifications
 * - Warning/confirmation dialogs
 * - Success messages
 */

// capsule type constants
export const CAPSULE_TYPE_TEXT = 'Capsule Type';
export const ADD_CAPSULE_TYPE_TEXT = 'Add Capsule Type';
export const EDIT_CAPSULE_TYPE_TEXT = 'Edit Capsule Type';
export const CAPSULE_TYPE_IS_CREATING_TEXT = 'Capsule Type is creating...';
export const CAPSULE_TYPE_IS_UPDATED_TEXT = 'Capsule Type is updated...';

// capsule price constants
export const ADD_CAPSULE_PRICE_TEXT = 'Add Capsule Price';
export const EDIT_CAPSULE_PRICE_TEXT = 'Edit Capsule Price';
export const CAPSULE_PRICE_IS_CREATING_TEXT = 'Capsule Price is creating...';
export const CAPSULE_PRICE_IS_UPDATED_TEXT = 'Capsule Price is updated...';

// base coating constants
export const BASE_COATING_TEXT = 'Base Coating';
export const ADD_BASE_COATING_TEXT = 'Add Base Coating';
export const EDIT_BASE_COATING_TEXT = 'Edit Base Coating';
export const BASE_COATING_IS_CREATING_TEXT = 'Base Coating is creating...';
export const BASE_COATING_IS_UPDATED_TEXT = 'Base Coating is updated...';

// messages

// Account/Authentication Messages
export const DEMO_ACCOUNT_TEXT = 'You are currently using a demo account';
export const FORGOT_PASSWORD_SUBTITLE =
  "Please enter the email address associated with your account, and we'll email you a link to reset your password.";
export const PASSWORD_SET_SUCCESS_SUBTITLE =
  'Your new password has been securely saved. Please make sure to remember this password, as it will be necessary to log in to your account in the future.';
export const REQUEST_SENT_SUBTITLE =
  "We've sent a password reset link to your email. Please check and reset your password by using that link.";

// Error Messages
export const ADD_BLEND_ERROR_MESSAGE = 'Please select at least 1 ingredient to create blend';
export const ADD_INGREDIENT_ERROR_MESSAGE = 'Please select at least 1 ingredient';
export const FORM_FILLED_ERROR_MESSAGE_TEXT = 'Please fill the form';

export const INGREDIENTS_VALUE_ERROR_MESSAGE_TEXT = 'Please enter valid value for all ingredients';
export const LIMIT_UPTO_300_MSG = 'Please limit your input to 300 characters';
export const PAGE_NOT_FOUND_MSG_TEXT = `Sorry, we couldn't find the page you're looking for. Perhaps you've mistyped the URL? Be sure to check your spellings.`;
export const ACCESS_DENIED_MSG_TEXT = `Sorry, you don't have access to this page. Please contact your administrator for assistance.`;
export const OVERAGE_INFO_MESSAGE = 'Enter any number from 0 to 1 as overage';
export const OPT_MUST_BE_SIX_DIGIT_MESSAGE = '2FA code must be exactly six digits';

export const DEACTIVATION_WARNING_TEXT =
  'After deactivation, the user will no longer be able to log in. However, their subscription will remain active and must be canceled manually.';
export const NAME_MUST_CONTAIN_ONLY_LETTERS_AND_SPACE_TEXT = 'Name must contain only letters and spaces';
export const RECAPTCHA_NOT_READY_TEXT = 'reCAPTCHA is not ready yet';
export const RECAPTCHA_FAILED_TO_GENERATE_TOKEN_TEXT = 'Failed to generate reCAPTCHA token';

// Success Messages
export const CONTACT_UPDATE_SUCCESS_MESSAGE = 'Contact updated successfully.';
export const OPT_SENT_MESSAGE = 'A 6-digit 2FA Code has been sent to your email';
export const CANCEL_SUBSCRIPTION_TEXT =
  'Your subscription will be canceled at the end of the current billing period. This action cannot be undone.';
export const SUBSCRIPTION_EXPIRED_MSG_TEXT =
  'Your subscription has expired. Please contact your admin to renew your subscription to continue using our services.';
export const EMAIL_SENT_SUCCESS_TITLE = 'Email Sent Successfully!';
export const EMAIL_SENT_SUCCESS_SUBTITLE =
  'Please check your email for the verification link. The link will expire in 24 hours. If you do not receive the email within a few minutes, please check your spam folder.';
export const YOU_WILL_BE_CHARGED_AFTER_7_DAYS_TEXT = 'You will be charged after 7 days free trial';
export const ACCOUNT_ATTACH_SUCCESS_MSG = 'Bank account added successfully';

// Warning/Confirmation Messages
export const UNSAVED_FORMULA_MESSAGE =
  'Are you sure you want to leave this page? You have unsaved data in your formula.';

/**
 * Query Constants
 * Defines commonly used query strings for API requests and data fetching.
 */
export const TOKEN_QUERY_TEXT = 'token';
export const TAB_QUERY_TYPE = 'tab';

/**
 * User Interface Messages
 * - User notifications, alerts, and form guidance
 */
export const UI_MESSAGES = {
  DEMO_ACCOUNT: 'You are currently using a demo account',
  FORM_UNSAVED: 'Are you sure you want to leave this page? You have unsaved data in your formula.',
  INPUT_LIMIT: 'Please limit your input to 300 characters',
  CONTACT_UPDATE_SUCCESS: 'Contact updated successfully',
  PAGE_NOT_FOUND: "Sorry, we couldn't find the page you're looking for. Please check the URL and try again.",
};

/**
 * Authentication & Account Flow
 * - Messages for password reset and account verification flows
 */
export const AUTH_MESSAGES = {
  FORGOT_PASSWORD: 'Please enter your account email to receive a password reset link',
  RESET_REQUEST_SENT: 'Password reset link sent to your email',
  PASSWORD_SET_SUCCESS: 'Your new password has been securely saved',
};

/**
 * Form Validation
 * - Specific error messages for form fields and submissions
 */
export const VALIDATION_MESSAGES = {
  INGREDIENTS_INVALID: 'Please enter valid values for all ingredients',
  BLEND_MIN_INGREDIENTS: 'Select at least 1 ingredient to create blend',
  OVERAGE_RANGE: 'Enter any number between 0 and 1 for overage',
};

/**
 * Agreement Content
 * - Terms and conditions text blocks
 */
export const AGREEMENT_CONTENT = {
  CHECKBOX: 'I agree to the terms and conditions as set out by the user agreement.',
  SECTION_1: `This website (the "Site") is owned and operated by Path Forward Formulator, LLC. These terms apply to all users of this Site. Your use is also governed by our Privacy Policy.`,
  SECTION_2: `By accessing this Site, you agree to be bound by these Terms. We reserve the right to modify these Terms at any time. Continued use constitutes acceptance of changes.`,
};

export const AGREEMENT_CHECKBOX_TEXT =
  'I agree to the terms and conditions as set out by the user agreement.';
export const AGREEMENT_PARA_2_TEXT = `Please read these Terms of Use carefully before accessing or using this Site. All information,
features, products, and services available on this Site are conditioned upon your acceptance of
these Terms of Use. If you do not agree to be bound by these Terms of Use, please do not use this
Site. Path Forward Formulator reserves the right to change any part of these Term of Use, and its
Privacy Policy, at any time without notice. Your continued use of this Site constitutes your
agreement to these Terms of Use.`;
export const AGREEMENT_PARA_1_TEXT = `This website (the "Site") is owned and operated by Path Forward Formulator, LLC, an Illinois limited
liability company ("Path Forward Formulator," "us," "we" or "our"). Whether you are a browser,
vendor, supplier, customer, client, or merchant, these terms of use ("Terms of Use") apply to your
use of this Site. Additionally, your use of this Site is governed by the Privacy Policy, which is
incorporated herein by reference.`;

/**
 * Nutrition Labels
 * - Mapping for nutritional terminology
 */
export const NUTRITION_LABELS = {
  ADDED_SUGAR: 'Added Sugar',
  CARBOHYDRATES: 'Carbohydrates',
  PROTEIN: 'Protein',
  CALORIES: 'Calories',
  CHOLESTEROL: 'Cholesterol',
  FIBER: 'Dietary Fiber',
  MOISTURE: 'Moisture',
  MONOUNSATURATED_FAT: 'Monounsaturated Fat',
  POLYUNSATURATED_FAT: 'Polyunsaturated Fat',
  SATURATED_FAT: 'Saturated Fat',
  TOTAL_FAT: 'Total Fat',
  TOTAL_SUGARS: 'Total Sugars',
  TRANS_FAT: 'Trans Fat',
} as const;

export const IMPORT_INGREDIENTS_TEXT = 'Import Ingredients';
export const CSV_FILE_TEXT = 'CSV File';
export const UPLOAD_FAILED_TEXT = 'Upload Failed';
export const UPLOAD_FILE_DESCRIPTION_TEXT = 'Upload a file to import';
export const UPLOAD_CONFIG = {
  ACCEPTED_FILE_TYPES: ['.csv'] as string[],
  MAX_FILE_SIZE: 1 * 1024 * 1024, // 1MB
  SUPPORTED_FORMATS: ['CSV'],
} as const;

export const UPLOAD_TEXT = {
  CLOSE: 'Close',
  UPLOAD_TITLE: 'Import Ingredients',
  UPLOAD_SUBTITLE: 'Upload a CSV file containing ingredient data',
  UPLOAD_BUTTON: 'Upload',
  UPLOADING: 'Uploading...',
  DOWNLOAD_SAMPLE: 'Download Sample',
  DRAG_DROP_TEXT: 'Drag and drop a CSV file here, or click to browse',
  DROP_HERE: 'Drop your file here',
  UPLOAD_CSV: 'Upload CSV File',
  FILE_READY: 'File Ready',
  CSV_ONLY: 'CSV files only',
  MAX_SIZE: 'Max 1MB',
  REMOVE_FILE: 'Remove file',
  SPECIAL_CHARS_ERROR: 'CSV contains special characters that are not allowed',
  INVALID_CONTENT_ERROR: 'CSV contains invalid content',
  NO_FILE_SELECTED: 'No file selected',
  INVALID_FILE_TYPE: 'Invalid file type. Please select a CSV file.',
  FILE_SIZE_TOO_LARGE: 'File size too large. Maximum size is 1MB.',
} as const;
export const SOMETHING_WENT_WRONG_TEXT = 'Something went wrong';
export const IMPORT_INGREDIENT_SUCCESS_TEXT = 'Ingredient imported successfully';
export const IMPORT_INGREDIENT_FAILED_TEXT = 'Ingredient import failed';
export const IMPORT_TEXT = 'import';
export const SAVE_AND_LEAVE_TEXT = 'Save & Leave';

export const DESIRED_SERVING_SIZE_INFO = 'Desired serving size is just used for the cost/weight calculation.';
export const SERVING_PER_CONTAINER_INFO =
  'Serving per container is just used for the cost/weight calculation.';

// Admin add staff trial
export const TRIAL_END_MIN_MESSAGE = 'Trial end date must be after today.';
export const TRIAL_END_MAX_MESSAGE = 'Trial end date cannot be more than 730 days from today.';
export const TRIAL_MAX_DAYS = 730;
